// When the week's included usage resets, in the reader's own clock. The gateway sends `resets_at`
// (epoch seconds, sometimes milliseconds) beside the old `resets_on` weekday. The browser knows the
// viewer's time zone, so the exact hour is formatted here: "Mon 12:00 AM PDT". The weekday alone is
// the fallback for a payload that predates `resets_at`.
export function resetLabel(usage, now = Date.now(), locale = undefined) {
  const raw = Number(usage?.resets_at);
  if (Number.isFinite(raw) && raw > 0) {
    const ms = raw > 1e12 ? raw : raw * 1000;
    const d = new Date(ms);
    const sameDay = new Date(now).toDateString() === d.toDateString();
    const time = d.toLocaleTimeString(locale, { hour: "numeric", minute: "2-digit", timeZoneName: "short" });
    if (sameDay) return `today ${time}`;
    const tomorrow = new Date(now + 86_400_000).toDateString() === d.toDateString();
    if (tomorrow) return `tomorrow ${time}`;
    return `${d.toLocaleDateString(locale, { weekday: "short" })} ${time}`;
  }
  return usage?.resets_on ? String(usage.resets_on) : "";
}
